export const timing = [
  {
    id: '1',
    'score-title': 'Cycle I',
    start: '2',
    end: '2',
    'duration-format': '0:01:03',
    'duration-s': '63',
    'duration-text': '1:03',
    'audio-start-time': '0',
    'audio-end-time': '63',
    'audio-start-xpos': '24',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '2',
    'score-title': 'Exploration 1',
    start: '2',
    end: '1',
    'duration-format': '0:00:58',
    'duration-s': '58',
    'duration-text': '0:58',
    'audio-start-time': '0',
    'audio-end-time': '58',
    'audio-start-xpos': '24',
    'audio-end-xpos': '832',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '97.65258216',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.976525822',
  },
  {
    id: '3',
    'score-title': 'Ideation',
    start: '2',
    end: '3',
    'duration-format': '0:01:01',
    'duration-s': '61',
    'duration-text': '1:01',
    'audio-start-time': '0',
    'audio-end-time': '61',
    'audio-start-xpos': '24',
    'audio-end-xpos': '792',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '92.95774648',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.929577465',
  },
  {
    id: '4',
    'score-title': 'Seeking a Common Language 1',
    start: '2',
    end: '2',
    'duration-format': '0:01:00',
    'duration-s': '60',
    'duration-text': '1:00',
    'audio-start-time': '0',
    'audio-end-time': '60',
    'audio-start-xpos': '24',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '5',
    'score-title': 'The Spark I',
    start: '2',
    end: '2',
    'duration-format': '0:00:56',
    'duration-s': '56',
    'duration-text': '0:56',
    'audio-start-time': '0',
    'audio-end-time': '56',
    'audio-start-xpos': '24',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '6',
    'score-title': 'Seeking a Common Language 2',
    start: '2',
    end: '2',
    'duration-format': '0:00:32',
    'duration-s': '32',
    'duration-text': '0:32',
    'audio-start-time': '0',
    'audio-end-time': '32',
    'audio-start-xpos': '24',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '7',
    'score-title': '22 Referees & Pitching',
    start: '2',
    end: '2',
    'duration-format': '0:02:00',
    'duration-s': '120',
    'duration-text': '2:00',
    'audio-start-time': '0',
    'audio-end-time': '120',
    'audio-start-xpos': '24',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '8',
    'score-title': 'Group Work 1',
    start: '2',
    end: '2',
    'duration-format': '0:01:31',
    'duration-s': '91',
    'duration-text': '1:31',
    'audio-start-time': '0',
    'audio-end-time': '91',
    'audio-start-xpos': '24',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '9',
    'score-title': 'Exploration 2',
    start: '3',
    end: '7',
    'duration-format': '0:00:30',
    'duration-s': '30',
    'duration-text': '0:30',
    'audio-start-time': '0',
    'audio-end-time': '30',
    'audio-start-xpos': '44',
    'audio-end-xpos': '712',
    'audio-start-xpos-percent': '5.164319249',
    'audio-end-xpos-percent': '83.56807512',
    'audio-start-xpos-p': '0.051643192',
    'audio-end-xpos-p': '0.835680751',
  },
  {
    id: '10',
    'score-title': 'Brainstorming',
    start: '1',
    end: '2',
    'duration-format': '0:01:11',
    'duration-s': '71',
    'duration-text': '1:11',
    'audio-start-time': '0',
    'audio-end-time': '71',
    'audio-start-xpos': '4',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '0.469483568',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.004694836',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '11',
    'score-title': 'Exploration 3',
    start: '3',
    end: '3',
    'duration-format': '0:00:42',
    'duration-s': '42',
    'duration-text': '0:42',
    'audio-start-time': '0',
    'audio-end-time': '42',
    'audio-start-xpos': '44',
    'audio-end-xpos': '792',
    'audio-start-xpos-percent': '5.164319249',
    'audio-end-xpos-percent': '92.95774648',
    'audio-start-xpos-p': '0.051643192',
    'audio-end-xpos-p': '0.929577465',
  },
  {
    id: '12',
    'score-title': 'The Spark II',
    start: '1',
    end: '2',
    'duration-format': '0:01:07',
    'duration-s': '67',
    'duration-text': '1:07',
    'audio-start-time': '0',
    'audio-end-time': '67',
    'audio-start-xpos': '4',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '0.469483568',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.004694836',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '13',
    'score-title': 'Swarm',
    start: '2',
    end: '2',
    'duration-format': '0:00:41',
    'duration-s': '41',
    'duration-text': '0:41',
    'audio-start-time': '0',
    'audio-end-time': '41',
    'audio-start-xpos': '24',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '14',
    'score-title': 'Exploration 4',
    start: '3',
    end: '2',
    'duration-format': '0:00:59',
    'duration-s': '59',
    'duration-text': '0:59',
    'audio-start-time': '0',
    'audio-end-time': '59',
    'audio-start-xpos': '44',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '5.164319249',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.051643192',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '15',
    'score-title': 'Exploration 5',
    start: '1',
    end: '2',
    'duration-format': '0:01:00',
    'duration-s': '60',
    'duration-text': '1:00',
    'audio-start-time': '0',
    'audio-end-time': '60',
    'audio-start-xpos': '4',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '0.469483568',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.004694836',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '16',
    'score-title': 'Exploration 6a',
    start: '4',
    end: '2',
    'duration-format': '0:01:48',
    'duration-s': '108',
    'duration-text': '1:48',
    'audio-start-time': '0',
    'audio-end-time': '108',
    'audio-start-xpos': '64',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '7.511737089',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.075117371',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '17',
    'score-title': 'Exploration 6b',
    start: '3',
    end: '2',
    'duration-format': '0:01:13',
    'duration-s': '73',
    'duration-text': '1:13',
    'audio-start-time': '0',
    'audio-end-time': '73',
    'audio-start-xpos': '44',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '5.164319249',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.051643192',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '18',
    'score-title': 'Seeking a Common Language 3',
    start: '2',
    end: '2',
    'duration-format': '0:01:57',
    'duration-s': '117',
    'duration-text': '1:57',
    'audio-start-time': '0',
    'audio-end-time': '117',
    'audio-start-xpos': '24',
    'audio-end-xpos': '812',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '95.30516432',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.953051643',
  },
  {
    id: '19',
    'score-title': 'Group Work 2',
    start: '2',
    end: '3',
    'duration-format': '0:00:48',
    'duration-s': '48',
    'duration-text': '0:48',
    'audio-start-time': '0',
    'audio-end-time': '48',
    'audio-start-xpos': '24',
    'audio-end-xpos': '792',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '92.95774648',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.929577465',
  },
  {
    id: '20',
    'score-title': 'Convergence',
    start: '2',
    end: '3',
    'duration-format': '0:01:47',
    'duration-s': '107',
    'duration-text': '1:47',
    'audio-start-time': '0',
    'audio-end-time': '107',
    'audio-start-xpos': '24',
    'audio-end-xpos': '792',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '92.95774648',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.929577465',
  },
  {
    id: '21',
    'score-title': 'Cycle II',
    start: '2',
    end: '3',
    'duration-format': '0:01:02',
    'duration-s': '62',
    'duration-text': '1:02',
    'audio-start-time': '0',
    'audio-end-time': '62',
    'audio-start-xpos': '24',
    'audio-end-xpos': '792',
    'audio-start-xpos-percent': '2.816901408',
    'audio-end-xpos-percent': '92.95774648',
    'audio-start-xpos-p': '0.028169014',
    'audio-end-xpos-p': '0.929577465',
  },
];
